
<ng-template [ngIf]="!isFileSaving">
  <div class="container">
    <header>
      <h1>{{ eventName }}</h1>
    </header>
    <div class="overlay2" *ngIf="isFileLoading">
      <div class="ring">
        <svg width="76" height="31" viewBox="0 0 96 41" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M63.7782 2.95119H76.0185V0.975586H63.7782V2.95119ZM18.6251 10.6671C18.6251 9.75786 19.3622 9.02077 20.2715 9.02077H72.7718C73.6811 9.02077 74.4182 9.75786 74.4182 10.6671V32.884C74.4182 33.7932 73.6811 34.5303 72.7718 34.5303H56.6308C59.9348 32.223 62.099 28.3725 62.099 24.0121C62.099 16.9518 56.425 11.2283 49.4257 11.2283C48.5014 11.2283 47.6001 11.3282 46.732 11.5177H27.2898C25.313 11.5177 23.7251 13.1318 23.7251 15.1049V37.3913C23.7251 39.3643 25.313 40.9784 27.2898 40.9784H96V39.0028H27.2898C26.4202 39.0028 25.7007 38.2894 25.7007 37.3913V15.1049C25.7007 14.2067 26.4202 13.4933 27.2898 13.4933H42.2215C38.9171 15.8005 36.7525 19.6513 36.7525 24.0121C36.7525 31.0724 42.4265 36.7959 49.4257 36.7959C50.3511 36.7959 51.2534 36.6959 52.1224 36.5059H72.7718C74.7722 36.5059 76.3938 34.8843 76.3938 32.884V10.6671C76.3938 8.66676 74.7722 7.04517 72.7718 7.04517H20.2715C18.2711 7.04517 16.6495 8.66677 16.6495 10.6671V28.6144C16.6495 29.5237 15.9124 30.2608 15.0032 30.2608H0V32.2364H15.0032C17.0035 32.2364 18.6251 30.6148 18.6251 28.6144V10.6671ZM60.1234 24.0121C60.1234 29.9975 55.3178 34.8203 49.4257 34.8203C43.5337 34.8203 38.7281 29.9975 38.7281 24.0121C38.7281 18.0267 43.5337 13.2039 49.4257 13.2039C55.3178 13.2039 60.1234 18.0267 60.1234 24.0121Z"
            fill="white" />
        </svg>
        <span class="loader"></span>
      </div>
    </div>
    <main>
      <h2 class="manrope">Get my photos!</h2>
      <p class="manrope">Upload a selfie and get all your photos from the event as a keepsake.</p>
      <div class="upload-section">
        <div class="upload-image">
          <img class="selfie-image" *ngIf="user_image == ''" src="assets/images/selfie-upload.png" alt="Add Selfie"
            id="selfie-preview" />
          <img class="selfie-image" *ngIf="user_image != ''" [src]="user_image" alt="Add Selfie" id="selfie-preview" />
        </div>
        <div class="button-container">
          <label for="file-upload" *ngIf="user_image == ''" class="remove-selfie-btn">Add Selfie</label>
          <label for="file-upload" *ngIf="user_image != ''" class="remove-selfie-btn">Edit</label>
          <input type="file" id="file-upload" accept="image/*" hidden (change)="onFileSelected($event)" />
          <!-- Remove Selfie Button -->

          <button *ngIf="user_image != ''" class="remove-selfie-btn" (click)="removeSelfie()">
            Remove
          </button>
        </div>
      </div>

      <form>
        <label for="name" class="manrope">Your Name</label>
        <input type="text" id="name" placeholder="Name" [(ngModel)]="user_name" name="name" class="nameText" />
        <label for="phone" class="manrope">Phone Number</label>
        <input type="tel" id="phone" placeholder="+91 Number" [(ngModel)]="mobile" name="phone" class="nameText" />
        <button type="submit" class="confirm-btn manrope" disabled
          *ngIf="user_image == '' && !user_name && !mobile">Confirm</button>
        <button type="button" class="confirm-btn manrope" (click)="saveSelfie()"
          *ngIf="user_image != '' && user_name && mobile">Confirm</button>
      </form>
    </main>
    <footer>
      <a href="#" class="skip-btn manrope" (click)="skipSelfie()">Skip for now</a>
    </footer>
  </div>
</ng-template>
<ng-template [ngIf]="isFileSaving">
  <!-- <p>{{eventId}}</p> -->
  <div #imgGif style="overflow-x: hidden;margin-top: 45%;"><img style="width: 100%;" src="assets/image_processing.gif"></div>

</ng-template>
<!-- 
<div class="container popup" *ngIf="isOpen">
  <header>
    <h1>{{ eventName }}</h1>
  </header>
  <main style="display: contents;">
    <div class="success-icon">
      <svg width="73" height="72" viewBox="0 0 73 72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" width="72" height="72" rx="36" fill="#28DE2E" fill-opacity="0.2" />
        <rect x="1" y="0.5" width="71" height="71" rx="35.5" stroke="#007204" stroke-opacity="0.07" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M52.5991 25.5698C53.5291 26.3918 53.6161 27.8138 52.7941 28.7498L35.5441 48.2498C35.3449 48.475 35.1025 48.658 34.8314 48.788C34.5602 48.918 34.2658 48.9924 33.9654 49.0066C33.665 49.0209 33.3649 48.9748 33.0826 48.8711C32.8004 48.7674 32.5418 48.6081 32.3221 48.4028L21.0721 37.9028C20.6393 37.4949 20.3856 36.9323 20.3664 36.3379C20.3472 35.7435 20.5641 35.1657 20.9697 34.7308C21.3753 34.2959 21.9366 34.0392 22.5308 34.0169C23.1251 33.9946 23.7041 34.2085 24.1411 34.6118L33.7111 43.5218L49.4311 25.7618C49.6271 25.54 49.8649 25.3592 50.1309 25.2295C50.3969 25.0998 50.6859 25.0239 50.9813 25.006C51.2767 24.9882 51.5727 25.0288 51.8523 25.1256C52.132 25.2223 52.3899 25.3732 52.6111 25.5698H52.5991Z"
          fill="#0B8F10" />
      </svg>
    </div>
    <h2>Your selfie has been updated!</h2>
    <p>We will notify you when your photos are available.</p>
    <button (click)="closePopup()">Close</button>
  </main>
</div> -->
<app-selfie-updated-popup [eventName]="eventName" [isOpen]="isOpen"></app-selfie-updated-popup>